import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiderbarComponent } from './layout/siderbar/siderbar.component';
import { DashboardadminRoutingModule } from './dashboardadmin-routing.module';
import { DashboardadminComponent } from './dashboardadmin/dashboardadmin.component';
import { HeaderComponent } from './layout/header/header.component';
import { CapturapanelprincipalComponent } from './pages/capturapanelprincipal/capturapanelprincipal.component';
import { AdministrarObrasControlComponent } from '../modules/administracion/components/administrar-obras-control/administrar-obras-control.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SiderbarComponent, DashboardadminComponent, HeaderComponent, AdministrarObrasControlComponent ],
  imports: [
    CommonModule,
    DashboardadminRoutingModule,
    ReactiveFormsModule,
  ]
})
export class DashboardadminModule { }
